function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#gleev-logo_svg__clip0_1832_564721)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.827 13L10.853 0h8.245c1.09 0 2.119.509 2.786 1.378l8.623 11.24-.45.382h-9.23z",
  fill: "url(#gleev-logo_svg__paint0_linear_1832_564721)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.827 13L10.853 0h8.245c1.09 0 2.119.509 2.786 1.378l8.623 11.24-.45.382h-9.23z",
  fill: "url(#gleev-logo_svg__paint1_radial_1832_564721)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.827 13h-9.232l-.288.59 3.008 3.923a3.269 3.269 0 010 3.974L10.853 26h8.245c1.09 0 2.119-.509 2.786-1.378l2.128-2.773a3.863 3.863 0 000-4.698L20.827 13z",
  fill: "url(#gleev-logo_svg__paint2_linear_1832_564721)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.935 0a3.511 3.511 0 00-2.779 1.369L1.441 8.77A6.921 6.921 0 000 13c0 1.532.507 3.02 1.44 4.23l5.716 7.401A3.51 3.51 0 009.935 26h9.163c.136 0 .272-.008.405-.023a3.514 3.514 0 01-2.373-1.346l-6.24-8.081a5.809 5.809 0 010-7.1l6.24-8.081A3.514 3.514 0 0119.503.024 3.495 3.495 0 0019.098 0H9.935z",
  fill: "url(#gleev-logo_svg__paint3_linear_1832_564721)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.935 0a3.511 3.511 0 00-2.779 1.369L1.441 8.77A6.921 6.921 0 000 13c0 1.532.507 3.02 1.44 4.23l5.716 7.401A3.51 3.51 0 009.935 26h9.163c.136 0 .272-.008.405-.023a3.514 3.514 0 01-2.373-1.346l-6.24-8.081a5.809 5.809 0 010-7.1l6.24-8.081A3.514 3.514 0 0119.503.024 3.495 3.495 0 0019.098 0H9.935z",
  fill: "url(#gleev-logo_svg__paint4_radial_1832_564721)",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.827 13h-9.23l-.289.59h9.23l.289-.59z",
  fill: "url(#gleev-logo_svg__paint5_linear_1832_564721)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.356 13.492h9.23l-.047.099h-9.23l.047-.099z",
  fill: "#2F2BAD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.132 0a3.512 3.512 0 012.752 1.377l8.623 11.24-.449.383L21.42 1.739A2.926 2.926 0 0019.132.59c-.893.01-1.734.43-2.282 1.14l-5.962 7.721a5.806 5.806 0 000 7.095l5.962 7.721c.548.711 1.389 1.13 2.282 1.14a2.926 2.926 0 002.287-1.147l2.128-2.774a3.269 3.269 0 000-3.974l-3.009-3.922.289-.591 3.184 4.151a3.863 3.863 0 010 4.697l-2.127 2.774A3.511 3.511 0 0119.132 26a3.511 3.511 0 01-2.745-1.37l-5.962-7.72A6.4 6.4 0 019.093 13a6.4 6.4 0 011.332-3.91l5.962-7.721A3.511 3.511 0 0119.132 0z",
  fill: "url(#gleev-logo_svg__paint6_linear_1832_564721)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.18 0h-.048a3.511 3.511 0 00-2.745 1.369l-5.962 7.72A6.4 6.4 0 009.093 13a6.4 6.4 0 001.332 3.911l5.962 7.72A3.511 3.511 0 0019.18 26a3.512 3.512 0 01-2.697-1.368l-5.961-7.72A6.4 6.4 0 019.191 13c0-1.416.469-2.792 1.332-3.91l5.961-7.721A3.512 3.512 0 0119.181 0z",
  fill: "url(#gleev-logo_svg__paint7_linear_1832_564721)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.117 12.95l-8.6-11.211A2.926 2.926 0 0019.181.592c.877.025 1.7.445 2.238 1.147l8.64 11.26.058-.05z",
  fill: "url(#gleev-logo_svg__paint8_linear_1832_564721)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.18 25.408h.05a2.926 2.926 0 002.287-1.147l2.128-2.774a3.268 3.268 0 000-3.974l-3.009-3.922.25-.513-.06-.078-.288.59 3.01 3.923a3.269 3.269 0 010 3.974l-2.129 2.774a2.927 2.927 0 01-2.238 1.147z",
  fill: "url(#gleev-logo_svg__paint9_linear_1832_564721)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.519 4.063h-2.346v15.363h2.346V4.063z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.134 13.362c.002 1.777.508 3.222 1.52 4.335v.002a5.061 5.061 0 001.747 1.241 5.03 5.03 0 002.1.405 4.7 4.7 0 002.279-.621 4.4 4.4 0 00.71-.55c.153-.138.3-.285.436-.441.052-.06.1-.124.144-.19h.114v3.993h-7.04v2.145h7.442a1.952 1.952 0 001.944-1.96V7.61h-2.346v1.469h-.114l-.353-.437a4.31 4.31 0 00-1.275-.837 4.418 4.418 0 00-1.944-.424 4.985 4.985 0 00-2.096.41 5.017 5.017 0 00-1.737 1.251c-1.023 1.104-1.533 2.545-1.531 4.321zm2.135.003c0-1.172.32-2.104.96-2.798a3.536 3.536 0 012.503-1.04c.937 0 1.837.374 2.502 1.04.64.692.961 1.624.963 2.798.002 1.173-.32 2.107-.963 2.8a3.541 3.541 0 01-2.502 1.038 3.541 3.541 0 01-2.503-1.038c-.64-.695-.96-1.628-.96-2.8zM65.305 15.673c.289.734.721 1.4 1.271 1.956a5.859 5.859 0 003.014 1.609 5.789 5.789 0 003.382-.357A5.923 5.923 0 0075.6 16.68c.229-.35.42-.72.572-1.106h-2.524c-.121.213-.264.41-.429.59a3.475 3.475 0 01-2.471 1.038 3.475 3.475 0 01-2.471-1.038c-.485-.533-.784-1.206-.899-2.02h9.165c.034-.257.053-.518.054-.78a6.073 6.073 0 00-.41-2.322 5.982 5.982 0 00-1.26-1.978 5.847 5.847 0 00-1.912-1.326 5.751 5.751 0 00-4.534 0 5.846 5.846 0 00-1.913 1.326 5.979 5.979 0 00-1.26 1.978 6.073 6.073 0 00-.409 2.322c-.02.79.118 1.576.406 2.31zm2.191-3.675a3.453 3.453 0 01.78-1.433 3.47 3.47 0 012.472-1.04 3.47 3.47 0 012.471 1.04c.364.398.623.876.778 1.433h-6.5zM53.76 17.63a5.807 5.807 0 01-1.27-1.957 5.9 5.9 0 01-.407-2.31 6.073 6.073 0 01.41-2.322 5.982 5.982 0 011.26-1.978 5.847 5.847 0 011.912-1.326 5.751 5.751 0 014.534 0 5.846 5.846 0 011.913 1.326c.545.567.973 1.24 1.26 1.978.286.739.425 1.528.41 2.322-.002.262-.02.523-.055.78h-9.164c.114.814.413 1.487.898 2.02a3.475 3.475 0 002.471 1.038c.926 0 1.814-.373 2.472-1.038.164-.18.307-.377.429-.59h2.523a6.054 6.054 0 01-.572 1.106 5.923 5.923 0 01-2.627 2.203 5.79 5.79 0 01-3.383.356 5.859 5.859 0 01-3.013-1.609zm1.7-7.065a3.453 3.453 0 00-.78 1.433h6.501a3.454 3.454 0 00-.777-1.433 3.47 3.47 0 00-2.472-1.04 3.47 3.47 0 00-2.471 1.04z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.853 7.607h2.46l2.51 9.456h1.117l2.51-9.456h2.46c-.366 1.336-.73 2.672-1.095 4.009-.71 2.603-1.42 5.207-2.133 7.81H80.08L76.853 7.607z",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "gleev-logo_svg__paint0_linear_1832_564721",
  x1: 20.68,
  y1: 0,
  x2: 20.68,
  y2: 13,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.054,
  stopColor: "#181759"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.188,
  stopColor: "#242189"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#201D7F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gleev-logo_svg__paint2_linear_1832_564721",
  x1: 18.333,
  y1: 26,
  x2: 18.333,
  y2: 13,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3836A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.184,
  stopColor: "#242291"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.388,
  stopColor: "#2B29A3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.478,
  stopColor: "#3330B7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.599,
  stopColor: "#3330B7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  stopColor: "#201E8E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gleev-logo_svg__paint3_linear_1832_564721",
  x1: 9.973,
  y1: 0,
  x2: 9.973,
  y2: 26,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AFADF2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.066,
  stopColor: "#504DC7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.293,
  stopColor: "#3834AC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.384,
  stopColor: "#2F2BAE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.481,
  stopColor: "#332FB6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.562,
  stopColor: "#2F2BAF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.653,
  stopColor: "#1F1C80"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.937,
  stopColor: "#1A1871"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0D0C31"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gleev-logo_svg__paint5_linear_1832_564721",
  x1: 11.293,
  y1: 13.296,
  x2: 20.68,
  y2: 13.296,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#222085"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3532A9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gleev-logo_svg__paint6_linear_1832_564721",
  x1: 9.093,
  y1: 0,
  x2: 30.69,
  y2: 25.847,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6159E4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A43D5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gleev-logo_svg__paint7_linear_1832_564721",
  x1: 19.605,
  y1: 0,
  x2: 19.605,
  y2: 26,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#958AFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#958AFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#958AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gleev-logo_svg__paint8_linear_1832_564721",
  x1: 19.605,
  y1: 0,
  x2: 19.605,
  y2: 26,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#958AFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#958AFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#958AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "gleev-logo_svg__paint9_linear_1832_564721",
  x1: 19.605,
  y1: 0,
  x2: 19.605,
  y2: 26,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#958AFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#958AFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#958AFF"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "gleev-logo_svg__paint1_radial_1832_564721",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "rotate(67.343 7.627 11.448) scale(14.0872 12.5112)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#111048"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.637,
  stopColor: "#111048",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "gleev-logo_svg__paint4_radial_1832_564721",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "rotate(146.906 9.973 2.963) scale(23.809 18.4519)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BDBBEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.698,
  stopColor: "#9896DF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "gleev-logo_svg__clip0_1832_564721"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h88v26H0z"
})));

var SvgGleevLogo = function SvgGleevLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 26,
    viewBox: "0 0 88 26",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/gleev-logo.26a9fe4a.svg";
export { SvgGleevLogo as ReactComponent };